/**
 * window.localStorage 浏览器永久缓存
 */
export const localStorage = {
  // 设置缓存
  set(key, val, options = {}) {
    let { expires } = options;
    if (typeof expires === "number") {
      expires = new Date().getTime() + expires * 86400 * 1000;
    } else if (typeof expires === "object") {
      expires = expires.getTime();
    }
    let value = JSON.stringify({
      expires,
      data: val,
    });
    window.localStorage.setItem(key, value);
  },
  // 获取永久缓存
  get(key) {
    let object = window.localStorage.getItem(key);
    if (!object) return "";
    object = JSON.parse(object);
    const { expires } = object;
    if (typeof expires === "number" && expires <= Date.now()) {
      window.localStorage.removeItem(key);
      return "";
    }
    return object.data;
  },
  // 移除永久缓存
  remove(key) {
    window.localStorage.removeItem(key);
  },
  // 移除全部永久缓存
  clear() {
    window.localStorage.clear();
  },
};

/**
 * window.sessionStorage 浏览器临时缓存
 */
export const sessionStorage = {
  // 设置临时缓存
  set(key, val) {
    // window.sessionStorage.setItem(key, JSON.stringify(val));
    let value = JSON.stringify({ data: val });
    window.sessionStorage.setItem(key, value);
  },
  // 获取临时缓存
  get(key) {
    let object = window.sessionStorage.getItem(key);
    // return JSON.parse(json);
    if (!object) return "";
    object = JSON.parse(object);
    const { expires } = object;
    if (typeof expires === "number" && expires <= Date.now()) {
      window.localStorage.removeItem(key);
      return "";
    }
    return object.data;
  },
  // 移除临时缓存
  remove(key) {
    window.sessionStorage.removeItem(key);
  },
  // 移除全部临时缓存
  clear() {
    window.sessionStorage.clear();
  },
};
